import L from 'leaflet';
import { maplibreGL } from '@maplibre/maplibre-gl-leaflet';
import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import './openFreeMap.css';
import { acquireForegroundWebgl } from './foregroundWebgl';

export const OPENFREEMAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/positron';
export const OPENFREEMAP_ATTRIBUTION_HTML = '<a href="https://openfreemap.org/" target="_blank" rel="noopener noreferrer">OpenFreeMap</a> · © <a href="https://openmaptiles.org/" target="_blank" rel="noopener noreferrer">OpenMapTiles</a> · Données © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>';

export interface OpenFreeMapLayerHandle {
  layer: L.MaplibreGL;
  remove: () => void;
  setFilter: (filter: string) => void;
  setVisible: (visible: boolean) => void;
}

export function addOpenFreeMapLayer(
  map: L.Map,
  options: { label: string; visible?: boolean; filter?: string },
): OpenFreeMapLayerHandle {
  const releaseForeground = acquireForegroundWebgl({ kind: 'maplibre', label: options.label });
  let removed = false;
  let layer: L.MaplibreGL;

  try {
    layer = maplibreGL({
      style: OPENFREEMAP_STYLE_URL,
      interactive: false,
      attributionControl: false,
      maxZoom: 19,
    }).addTo(map) as L.MaplibreGL;
  } catch (error) {
    releaseForeground();
    throw error;
  }

  const onMapUnload = () => releaseForeground();
  map.once('unload', onMapUnload);

  const setVisible = (visible: boolean) => {
    layer.getContainer().style.visibility = visible ? 'visible' : 'hidden';
  };
  const setFilter = (filter: string) => {
    layer.getCanvas().style.filter = filter || 'none';
  };

  setVisible(options.visible !== false);
  setFilter(options.filter || 'none');

  return {
    layer,
    setFilter,
    setVisible,
    remove: () => {
      if (removed) return;
      removed = true;
      map.off('unload', onMapUnload);
      try {
        if (map.hasLayer(layer)) map.removeLayer(layer);
      } finally {
        releaseForeground();
      }
    },
  };
}

export { L };
